import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';

const STATUS_VARIANTS = {
    active: 'success',
    error: 'danger',
    deprecated: 'dark',
    pending: 'warning',
    new: 'info',
    disabled: 'dark',
};

export default function DataSourceStatusBadge({ status }) {
    const variant = STATUS_VARIANTS[status] || 'secondary';

    return (
        <Badge bg={variant} className="text-capitalize">
            {status}
        </Badge>
    );
}

DataSourceStatusBadge.propTypes = {
    status: PropTypes.string.isRequired,
};
